<div appTheme>
    <div class="main-container scrolling fixed-width-container"
        [ngClass]="{'external-terms-or-privacy': isExternalTermsOrPrivacy}">
        <div class="container col-sm-12">
            <h1>Terms of Service</h1>
            <hr>
            <span class="name">
                END USER LICENSE AGREEMENT (WINDOWS)
            </span>
            <p>
                THIS IS AN AGREEMENT MADE BY AND BETWEEN YOU AND THE TORO COMPANY AND OUR AFFILIATES AND BUSINESS UNITS
                WORLDWIDE (“TORO”) CONCERNING YOUR ACCESS TO
                AND USE OF THIS APPLICATION (THE “APP”). PLEASE READ THIS AGREEMENT CAREFULLY. BY USING THE APP, YOU
                ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD
                THIS AGREEMENT AND AGREE TO BE BOUND BY ITS TERMS AND CONDITIONS. IF YOU DO NOT AGREE, YOU MAY NOT
                ACCESS OR USE THE APP, AND YOU MUST UNINSTALL THE
                APP FROM ANY DEVICE OWNED OR CONTROLLED BY YOU.
            </p>
            <p>
                THIS AGREEMENT REQUIRES BINDING ARBITRATION TO RESOLVE ANY DISPUTE OR CLAIM ARISING OUT OF OR RELATING
                IN ANY WAY TO THIS AGREEMENT OR YOUR ACCESS
                TO OR USE OF THE APP, AND YOU AGREE THAT ANY SUCH DISPUTE OR CLAIM WILL BE RESOLVED ONLY ON AN
                INDIVIDUAL BASIS AND NOT IN A CLASS, CONSOLIDATED OR
                REPRESENTATIVE ACTION OR ARBITRATION . PLEASE REVIEW SECTION 14 CAREFULLY TO UNDERSTAND YOUR RIGHTS AND
                OBLIGATIONS WITH RESPECT TO THE RESOLUTION
                OF ANY DISPUTE OR CLAIM ARISING OUT OF OR RELATING IN ANY WAY TO THIS AGREEMENT OR YOUR ACCESS TO OR USE
                OF THE APP.
            </p>
            <p>1. <u>Governing Documents</u>. This Agreement incorporates by reference: (a) the Terms of Use at
                https://www.toro.com/en/legal/terms-of-use; (b) the
                Privacy
                Policy at https://www.toro.com/en/legal/privacy-policy (the “Privacy Policy”); and (c) any usage
                guidelines posted by Toro (collectively, “Governing
                Documents”). By using the App, you agree to be bound by the Governing Documents.</p>
            <p>2. <u>License</u>. Subject to your compliance in all material respects with the terms and conditions of
                this Agreement, Toro grants you a restricted,
                non-exclusive, non-transferable, revocable license to install and use the App in machine-executable,
                object code form only on the number of Windows
                devices that you own and control and that are associated with your Microsoft account, subject to the
                following limitations on the maximum total
                number of such Windows devices: (a) for the Windows Store on Windows 8.x operating system, up to
                eighty-one (81) personal Windows 8, Windows RT or
                successor tablets and personal computers; (b) for the Windows Store on Windows Phone 8.x, up to five (5)
                Windows Phone devices; and (c) for the
                Windows Store on Windows 10, up to ten (10) Windows devices.</p>
            <p>3. <u>Restrictions</u>. You may not: (a) use, copy, print, modify, adapt, create derivative works from,
                market, deliver, rent, lease, sublicense,
                make, have
                made, assign, pledge, transfer, sell, offer to sell, import, reproduce, distribute, publicly perform,
                publicly display or otherwise grant rights to
                the App, or any copy thereof, in whole or in part, except as expressly permitted under this Agreement;
                (b) reverse engineer, disassemble, decompile
                or translate the App, or otherwise attempt to derive the source code, architectural framework or the
                data records of the App, or authorize any third
                party to do any of the foregoing; (c) access the App for purposes of developing, marketing, selling or
                distributing any product or service that
                competes with or includes features substantially similar to the App; (d) loan, resell or distribute the
                App, or any part thereof, in any way; or (e)
                use the App in any way that does not comply with all applicable laws and regulations.</p>
            <p>4. <u>Ownership</u>. Toro or its licensors and suppliers own all rights, title and interest in the App
                (including, but not limited, to all
                copyrights,
                patents, patent applications, trade secrets, trademarks, source code, text and any images, photographs,
                icons, graphics, animations, video, audio,
                music, and all other materials incorporated within the App), and the App is protected by U.S. and
                international copyright and other intellectual
                property laws and treaties. The App is licensed, not sold, to you for use only under the terms and
                conditions of this Agreement. Toro reserves all
                rights not expressly granted to you.</p>
            <p>5. <u>Personal Information</u>. You acknowledge and agree that by using the App, Toro may receive certain
                information about you, including personal
                information, and Toro may collect, use and disclose such information in accordance with the Privacy
                Policy.</p>
            <p>6. <u>NO WARRANTY</u>. YOUR USE OF THE APP IS AT YOUR SOLE RISK. THE APP IS PROVIDED ON AN "AS IS" AND
                "AS AVAILABLE" BASIS, WITH ALL FAULTS. TO THE
                MAXIMUM
                EXTENT PERMITTED BY APPLICABLE LAW, TORO AND ITS PARENTS, SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS,
                EMPLOYEES, AGENTS, PARTNERS AND LICENSORS
                (COLLECTIVELY, “TORO PARTIES”) EXPRESSLY DISCLAIM ALL WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER
                EXPRESS OR IMPLIED OR ARISING FROM STATUTE,
                COURSE OF DEALING, USAGE OF TRADE OR OTHERWISE, INCLUDING, BUT, NOT LIMITED TO, THE IMPLIED WARRANTIES
                OR CONDITIONS OF MERCHANTABILITY,
                MERCHANTABLE QUALITY, QUALITY OR FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. TORO PARTIES
                MAKE NO WARRANTY THAT: (i) THE APP WILL MEET
                YOUR REQUIREMENTS; (ii) ACCESS TO THE APP WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE; OR (iii)
                THE RESULTS THAT MAY BE OBTAINED FROM USE OF
                THE APP WILL BE ACCURATE OR RELIABLE.</p>
            <p>7. <u>LIMITATION OF LIABILITY</u>. YOU ACKNOWLEDGE AND AGREE THAT TORO PARTIES SHALL NOT BE LIABLE FOR
                ANY INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
                PUNITIVE OR CONSEQUENTIAL DAMAGES, INCLUDING, BUT NOT LIMITED TO, DAMAGES ARISING FROM ANY TYPE OR
                MANNER OF COMMERCIAL, BUSINESS OR FINANCIAL LOSS,
                EVEN IF TORO PARTIES HAD ACTUAL OR CONSTRUCTIVE KNOWLEDGE OF THE POSSIBILITY OF SUCH DAMAGES AND
                REGARDLESS OF WHETHER SUCH DAMAGES WERE
                FORESEEABLE. IN NO EVENT SHALL TORO’S TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATING TO
                THIS AGREEMENT OR YOUR ACCESS TO OR USE OF
                THE APP EXCEED $50. CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION
                OR LIMITATION OF CERTAIN DAMAGES. IF THESE
                LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT APPLY TO
                YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.</p>
            <p>8. <u>Indemnification</u>. You agree to indemnify and hold Toro Parties harmless from and against any
                claim, demand, loss, damage, cost, liability
                and
                expense, including reasonable attorneys' fees, resulting from or arising out of your: (a) access to or
                use of the App; (b) violation of this
                Agreement or any law or regulation; or (c) violation of any rights of another party.</p>
            <p>9. <u>Termination</u>. This Agreement is effective until terminated by you or Toro. Your rights under
                this Agreement shall terminate automatically
                without
                notice from Toro if you violate any of the terms of this Agreement. Upon termination of this Agreement,
                all rights granted to you under this
                Agreement shall immediately terminate, but all other provisions shall survive termination.</p>
            <p>10. <u>Changes to App</u>. Toro reserves the right to modify or discontinue, temporarily or permanently,
                the App or any product or service to which
                it
                connects, with or without notice and without liability to you. Toro may at its sole discretion from time
                to time develop patches, bug fixes,
                updates, upgrades and other modifications to improve the performance of the App or related products or
                services (“Updates”). Toro may develop
                Updates that require installation by you before you continue to access or use the App or related
                products or services. Updates may also be
                automatically installed without providing any additional notice to you or receiving any additional
                consent from you. The manner in which Updates may
                be automatically downloaded and installed is determined by settings on your device and its operating
                system.</p>
            <p> 11. <u>Legal Compliance</u>. You represent and warrant that you are not: (a) located in a country that
                is subject to a U.S. Government embargo or
                designated by the
                U.S. Government as a “terrorist supporting” country; and (b) listed on any U.S. Government list of
                prohibited or restricted parties, including, but
                not
                limited to, the Specially Designated Nationals List.</p>

            <p> 12. <u>U.S. Government Entities</u>. This section applies to access to or use of the App by a branch or
                agency of the United States Government. The
                App consists of “commercial computer software” and “commercial computer software documentation” as such
                terms are used in 48 C.F.R. 12.212 and
                qualifies as
                “commercial
                items” as defined in 48 C.F.R. 2.101. The App is provided to the United States Government: (a) for
                acquisition by or on behalf of civilian agencies,
                consistent with the policy set forth in 48 C.F.R. 12.212; or (b) for acquisition by or on behalf of
                units of the Department of Defense, consistent
                with
                the policies set forth in 48 C.F.R. 227.7202-1 and 227.7202-3. The United States Government shall
                acquire only those rights set forth in this
                Agreement
                with respect to the App, and any access to or use of the App by the United States Government
                constitutes: (i) agreement by the United States
                Government
                that that the App is “commercial computer software” and “commercial computer software documentation” as
                defined in this section; and (ii) acceptance
                of
                the rights and obligations herein.</p>
            <p> 13. <u>Governing Law</u>.</p>
            <p class="p-indent">This Agreement shall be governed by and construed and enforced in accordance with the
                United States Federal Arbitration Act, other
                applicable
                federal laws and the laws of the State of Minnesota, without regard to conflict of laws principles. The
                United Nations Convention on Contracts for
                the International Sale of Goods is specifically excluded from application to this Agreement.</p>
            <p> 14. <u>BINDING ARBITRATION AND CLASS ACTION WAIVER</u>. ANY DISPUTE OR CLAIM ARISING OUT OF OR RELATING
                IN ANY WAY TO THIS AGREEMENT OR YOUR ACCESS
                TO OR USE OF THE APP, INCLUDING, BUT NOT LIMITED TO, THE VALIDITY, APPLICABILITY OR INTERPRETATION OF
                THIS AGREEMENT, SHALL BE RESOLVED BY BINDING
                ARBITRATION RATHER THAN IN COURT, EXCEPT THAT YOU MAY ASSERT CLAIMS IN SMALL CLAIMS COURT IF YOUR CLAIMS
                QUALIFY. THERE IS NO JUDGE OR JURY IN
                ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED.</p>
            <p class="p-indent">The arbitration will be conducted by the American Arbitration Association (AAA) under
                its then-applicable rules, including (as
                appropriate) its Supplementary Procedures for Consumer-Related Disputes. The AAA's rules are available
                at <a href="http://www.adr.org/" target="_blank">http://www.adr.org/</a>
                . Payment of all
                filing, administration and arbitrator fees will be governed by the AAA’s rules.</p>
            <p class="p-indent">
                The arbitration shall be conducted in the English language by a single independent and neutral
                arbitrator. For any hearing conducted in person as
                part of the arbitration, you agree that t he hearing will be conducted in Bloomington, Minnesota or the
                city within the United States in which you
                reside.
            </p>
            <p class="p-indent">
                The decision of the arbitrator shall be final and binding. Judgment on the arbitral award may be entered
                in any court of competent jurisdiction.
            </p>
            <p class="p-indent">
                WE EACH AGREE THAT ANY DISPUTE OR CLAIM ARISING OUT OF OR RELATING IN ANY WAY TO THIS AGREEMENT OR YOUR
                ACCESS TO OR USE OF THE APP WILL BE RESOLVED
                ONLY ON AN INDIVIDUAL BASIS AND NOT IN A CLASS, CONSOLIDATED OR REPRESENTATIVE ACTION OR ARBITRATION. IF
                FOR ANY REASON A CLAIM PROCEEDS IN COURT
                RATHER THAN IN ARBITRATION, WE EACH WAIVE ANY RIGHT TO A JURY TRIAL AND AGREE THAT SUCH CLAIM SHALL BE
                BROUGHT ONLY IN THE UNITED STATES DISTRICT
                COURT FOR THE DISTRICT OF MINNESOTA (MINNEAPOLIS) OR, IF FEDERAL JURISDICTION IS NOT AVAILABLE, A COURT
                OF COMPETENT JURISDICTION IN HENNEPIN
                COUNTY, MINNESOTA. YOU HEREBY SUBMIT TO THE PERSONAL JURISDICTION AND VENUE OF SUCH COURTS AND WAIVE ANY
                OBJECTION ON THE GROUNDS OF VENUE, FORUM
                NON-CONVENIENS OR ANY SIMILAR GROUNDS WITH RESPECT TO ANY SUCH PROCEEDING.
            </p>
            <p class="p-indent">
                Notwithstanding anything to the contrary, you and Toro may seek injunctive relief and any other
                equitable remedies from any court of competent
                jurisdiction to protect our intellectual property rights, whether in aid of, pending or independently of
                the resolution of any dispute pursuant to
                the arbitration procedures set forth above.
            </p>
            <p>15. <u>General</u>. This Agreement constitutes the entire agreement between you and Toro concerning your
                access to and use of the App. It supersedes
                any prior or contemporaneous oral or written negotiations and agreements between you and Toro with
                respect to such subject matter. You may not
                assign any of your rights or obligations under this agreement to another party without the express
                written consent of Toro. The failure of Toro to
                exercise or enforce any right or provision of this Agreement shall not constitute a waiver of such right
                or provision. If any provision of this
                Agreement is held to be invalid or unenforceable under applicable law, then such provision shall be
                construed, limited, modified or, if necessary,
                severed to the extent necessary to eliminate its invalidity or unenforceability, without in any way
                affecting the remaining parts of this Agreement.
            </p>
            <br /><br /><br />
            <p>© The Toro Company {{currentYear}} - All Rights Reserved</p>
        </div>
    </div>
</div>
